import { HttpParams, httpResource } from '@angular/common/http';
import { computed, runInInjectionContext } from '@angular/core';
import { widgetHttpHeader } from 'scw-digital-boards-widgets';
import { oeeContext } from '../../../../core/interceptors/api-interceptor.interceptor';
import { IBaseResponse } from '../../../../utilities/http-utilities.service';
import { IWorkOrder } from '../../form-association/form-association.interface';
import { AdvancedFilterApiMatcher } from './advanced-filter-api-matcher';

export class WoAdvancedFilterApiMatcher extends AdvancedFilterApiMatcher {
  public override idValidationResource = runInInjectionContext(this.injector, () =>
    httpResource<IBaseResponse<IWorkOrder>>(() => ({
      context: oeeContext,
      headers: widgetHttpHeader,
      method: 'GET',
      params: new HttpParams().set('fields', 'id,woNumber'),
      reportProgress: true,
      url: `work-orders/${this.id}`,
    })),
  );
  public override label = computed(() => {
    return this.idValidationResource.status() === 'resolved'
      ? (this.idValidationResource.value()?.data.woNumber ?? '...')
      : '...';
  });
}
